var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.521 5.5a4.477 4.477 0 0 1 0 6.332l-34.19 34.19H4V39.69L38.19 5.5a4.477 4.477 0 0 1 6.331 0Z",
    fill: "#2EBCFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9 15.122 4.898 9.12a9.004 9.004 0 0 0 10.48 12.568l23.001 23a4.477 4.477 0 0 0 6.331-6.33l-23-23.001A9.004 9.004 0 0 0 9.141 4.877l6.002 6.002-4.243 4.243Z",
    fill: "#985184"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.023 18.67 18.69 25l6.332 6.331L31.352 25l-6.33-6.331Z",
    fill: "#144496"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudio);
export default __webpack_public_path__ + "static/media/Studio.bbb1181b4ad730716129ba222c05bf9b.svg";
export { ForwardRef as ReactComponent };